import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col , Alert} from 'react-bootstrap';
import Message from '../../../components/Message';
import Loader from '../../../components/Loader';
import FormContainer from '../../../components/FormContainer';
import { toast } from 'react-toastify';
import { useLayout } from '../../../context/LayoutContext';

import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { useGetUsersQuery } from '../../../slices/usersApiSlice';
import { useGetAgenciesQuery } from '../../../slices/agencyApiSlice';

import {
  CATEGORY_OF_STAFF,
  REASON_FOR_REQUEST,
  SPECIALS_REASON,
} from '../../../utils/enums';

import {
  useGetShiftByIdQuery,
  useUpdateShiftMutation,
  useRecordActualFillerSwapMutation,
} from '../../../slices/shiftApiSlice';
import { useGetHospitalLocationsQuery } from '../../../slices/hospitalLocationApiSlice';

import { dublinDateTimeInputStr, dublinLocalToUtcISO } from '../../../utils/dublinTime';


const ShiftWardEditScreen = () => {
  const { id: shiftId } = useParams();
  const navigate = useNavigate();
const { setFluid } = useLayout();
const { userInfo } = useSelector((state) => state.auth);

const isManager = userInfo?.isManager === true;
const isAdmin = userInfo?.isAdmin === true;


  const [startDateTime, setStartDateTime] = useState('');
  const [endDateTime, setEndDateTime] = useState('');

  // Who actually worked: 'staff' or 'agency'
const [actualFillerType, setActualFillerType] = useState('staff');
const [actualfilledBy, setActualfilledBy] = useState(''); // ObjectId of User

const [actualFilledByAgency, setActualFilledByAgency] = useState('');
const [actualFilledByAgencyName, setActualFilledByAgencyName] = useState('');
const [actualFilledByAgencyWorkerName, setActualFilledByAgencyWorkerName] = useState('');
const [actualFilledByAgencyWorkerContact, setActualFilledByAgencyWorkerContact] = useState('');
const [actualFilledByAgencyWorkerEmail, setActualFilledByAgencyWorkerEmail] = useState('');

const { data: staffData } = useGetUsersQuery();
const { data: agenciesData } = useGetAgenciesQuery({ isActive: true });




const [actualStart, setActualStart] = useState('');
  const [actualFinish, setActualFinish] = useState('');
  const [actualPersonWorked, setActualPersonWorked] = useState('');
 
 const [actualStatus, setActualStatus] = useState('');

  const [hospitalLocationId, setHospitalLocationId] = useState('');
  const [wardDepartmentArea, setWardDepartmentArea] = useState('');
  const [reasonForRequest, setReasonForRequest] = useState('');
  const [reasonForRequestDetails, setReasonForRequestDetails] = useState('');
  const [categoryOfStaff, setCategoryOfStaff] = useState('');
  const [escort, setEscort] = useState(false);
  const [special, setSpecial] = useState(false);
  //const [typeOfShift, setTypeOfShift] = useState('');
  const [eccNumber, setEccNumber] = useState('');
  const [specialRequirements, setSpecialRequirements] = useState('');
  const [comments, setComments] = useState('');
const [stage2WardApprovalManager,setStage2WardApprovalManager]=useState('');
const [copyActualsChecked, setCopyActualsChecked] = useState(false);

const [recordActualFillerSwap] = useRecordActualFillerSwapMutation();


  
// Track if location has been changed from original
  const [locationChanged, setLocationChanged] = useState(false);
  const [originalLocationId, setOriginalLocationId] = useState('');

const [specialsReason, setSpecialsReason] = useState('');
//const [specialsReasonModalOpen, setSpecialsReasonModalOpen] = useState(false);
const [reasonModalOpen, setReasonModalOpen] = useState(false);
const [reasonForRequestDraft, setReasonForRequestDraft] = useState('');
const [specialsReasonDraft, setSpecialsReasonDraft] = useState('');



const localInputToUtcISO = (localStr) => {
  if (!localStr) return '';
  const [dateStr, timeStr] = localStr.split('T');
  return dublinLocalToUtcISO(dateStr, timeStr);
};


const [swapCancelledByType, setSwapCancelledByType] = useState('');
const [swapConfirmModalOpen, setSwapConfirmModalOpen] = useState(false);
const [pendingSwapPayload, setPendingSwapPayload] = useState(null);


const [swapAdvanceNoticeGiven, setSwapAdvanceNoticeGiven] = useState(null);

  // ─── Helper ───────────────────────────────────────────────────────────────────
/**
 * Convert a UTC ISO string to the value format required by <input type="datetime-local">,
 * expressed in the user's LOCAL timezone — not UTC.
 * e.g. "2024-03-10T09:00:00.000Z" in UTC+1 → "2024-03-10T10:00"
 */
const toLocalInput = (utcString) => {
  if (!utcString) return '';
  const d = new Date(utcString);
  const pad = (n) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
};

  const {
    data: shift,
    isLoading: loadingShift,
    error: errorShift,
  } = useGetShiftByIdQuery(shiftId);

  const {
    data: hospitalLocations,
    isLoading: loadingLocations,
    error: errorLocations,
  } = useGetHospitalLocationsQuery();

  const [updateShift, { isLoading: loadingUpdate }] = useUpdateShiftMutation();


  // Mirrors the backend's split decision, purely so we can branch before
// hitting the normal save path.
const needsFillerSwapSplit = () => {
  if (!shift?.poNumber) return false;
  const currentAgencyId = shift.actualFilledByAgency?._id || shift.actualFilledByAgency
    || shift.filledByAgency?._id || shift.filledByAgency || null;
  if (!currentAgencyId) return false;
  if (actualFillerType === 'staff') return true;
  return String(actualFilledByAgency) !== String(currentAgencyId);
};


  useEffect(() => {
    if (shift && hospitalLocations?.length > 0) {
      //setStartDateTime(shift.startDateTime?.slice(0, 16));
      //setEndDateTime(shift.endDateTime?.slice(0, 16));

      //setStartDateTime(toLocalInput(shift.startDateTime));
      //setEndDateTime(toLocalInput(shift.endDateTime));

      setStartDateTime(dublinDateTimeInputStr(shift.startDateTime));
      setEndDateTime(dublinDateTimeInputStr(shift.endDateTime));


      const selectedHospitalId =
        typeof shift.hospitalLocationId === 'string'
          ? shift.hospitalLocationId
          : shift.hospitalLocationId?._id;

      setHospitalLocationId(selectedHospitalId);

      const selectedLocation = hospitalLocations.find(
        (loc) => loc._id === selectedHospitalId
      );
      setWardDepartmentArea(selectedLocation?.wardDepartmentArea || '');

      setReasonForRequest(shift.reasonForRequest);
       setReasonForRequestDetails(shift.reasonForRequestDetails);
      setCategoryOfStaff(shift.categoryOfStaff);
      setEscort(shift.escort);
      setSpecial(shift.special);
      //setTypeOfShift(shift.typeOfShift);
      setEccNumber(shift.eccNumber);
      setSpecialRequirements(shift.specialRequirements);
      setComments(shift.comments);

      //setActualStart(shift.actualStart);
      //setActualFinish(shift.actualFinish);

      //setActualStart(toLocalInput(shift.actualStart));
      //setActualFinish(toLocalInput(shift.actualFinish));

      setActualStart(dublinDateTimeInputStr(shift.actualStart));
      setActualFinish(dublinDateTimeInputStr(shift.actualFinish));

      setActualPersonWorked(shift.actualPersonWorked);
      setActualStatus(shift.actualStatus);
      setStage2WardApprovalManager(userInfo._id);
      setSpecialsReason(shift.specialsReason || '');

      setActualfilledBy(shift.actualfilledBy?._id || shift.actualfilledBy || '');
      setActualFilledByAgency(shift.actualFilledByAgency?._id || shift.actualFilledByAgency || '');
      setActualFilledByAgencyName(shift.actualFilledByAgencyName || '');
      setActualFilledByAgencyWorkerName(shift.actualFilledByAgencyWorkerName || '');
      setActualFilledByAgencyWorkerContact(shift.actualFilledByAgencyWorkerContact || '');
      setActualFilledByAgencyWorkerEmail(shift.actualFilledByAgencyWorkerEmail || '');
      setActualFillerType(shift.actualFilledByAgency ? 'agency' : 'staff');

    }


  }, [shift, hospitalLocations, userInfo]);


const isFinalised = shift && (
  shift.actualStatus === 'Complete' ||
  shift.actualStatus === 'Not-Worked' ||
  !!shift.supersededByShiftId
);





          const handleSaveReasonChanges = async () => {
                  if (isFinalised) {
                    toast.error('This shift has been finalised and can no longer be changed.');
                    return;
                  }

                  if (!reasonForRequestDraft) {
                    toast.error('Please select a Reason for Request');
                    return;
                  }

                  const specialsApplicable = ['1-1 special', 'Cohorts'].some(
                    r => reasonForRequestDraft.toLowerCase() === r.toLowerCase()
                  );

                  if (specialsApplicable && !specialsReasonDraft.trim()) {
                    toast.error('Please select a Specials / Cohorts reason');
                    return;
                  }

                  try {
                    await updateShift({
                      shiftId,
                      reasonForRequest: reasonForRequestDraft,
                      specialsReason: specialsApplicable ? specialsReasonDraft : '',
                    }).unwrap();

                    setReasonForRequest(reasonForRequestDraft);
                    setSpecialsReason(specialsApplicable ? specialsReasonDraft : '');
                    setReasonModalOpen(false);
                    toast.success('Reason for Request updated');
                  } catch (err) {
                    toast.error(err?.data?.message || err.error || 'Failed to update reason');
                  }
                };


const handleConfirmSwap = async () => {
  if (!swapCancelledByType) {
    toast.error('Please select who is responsible for this replacement — Agency or Beaumont.');
    return;
  }
  if (swapCancelledByType === 'Beaumont' && swapAdvanceNoticeGiven === null) {
    toast.error('Please confirm whether the agency was given 12 hours notice.');
    return;
  }

  try {
    const result = await recordActualFillerSwap({
      ...pendingSwapPayload,
      cancelledByType: swapCancelledByType,
      ...(swapCancelledByType === 'Beaumont' && { advanceNoticeGiven: swapAdvanceNoticeGiven }),
    }).unwrap();

    toast.success(
      `Original shift preserved as Not-Worked (replaced by ${swapCancelledByType}).` +
      `${result.chargeApplies ? ' ⚠️ A charge applies — the agency was not given 12 hours notice.' : ''} Opening the new shift now...`
    );

    setSwapConfirmModalOpen(false);
    navigate(`/${window.location.pathname.includes('/admin/') ? 'admin' : 'manager'}/shiftsWard/${result.newShift._id}/edit`);
  } catch (err) {
    toast.error(err?.data?.message || err.error || 'Failed to record the filler change');
  }
};


  // Handle hospital location change
  const handleHospitalLocationChange = (e) => {
    const newHospitalId = e.target.value;
    setHospitalLocationId(newHospitalId);
    
    // Find the selected location and update wardDepartmentArea
    const selectedLocation = hospitalLocations.find(loc => loc._id === newHospitalId);
    if (selectedLocation) {
      setWardDepartmentArea(selectedLocation.wardDepartmentArea);
      
      // Check if location changed from original
      setLocationChanged(newHospitalId !== originalLocationId);
    }
  };

  // SEPARATE FUNCTION: Save only location changes and close
  const handleSaveLocationOnly = async () => {
    if (!locationChanged) {
      toast.info('No location changes to save');
      return;
    }

    try {
      // Only send location-related fields
      await updateShift({
        shiftId,
        hospitalLocationId,
        wardDepartmentArea,
        locationUpdated: true, // Flag for backend
        updatedBy: userInfo._id,
      }).unwrap();
      
      toast.success('Shift location updated successfully');
      navigate('/manager/approved-filled'); // Close form and go back
      
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };


  // SEPARATE FUNCTION: Save all changes (actuals + location if changed) and close
    const handleSaveAllChanges = async () => {


      if (['1-1 special', 'Cohorts'].some(r => reasonForRequest?.toLowerCase() === r.toLowerCase())
    && !specialsReason) {
  toast.error('Please add a Specials / Cohorts reason before saving actuals');
  return;
}


  // ── Guard: shift must have already finished ────────────────────────────
  const shiftEndUtc = new Date(shift.endDateTime);
  if (shiftEndUtc > new Date()) {
    toast.error(
      `This shift hasn't finished yet — it ends at ${shiftEndUtc.toLocaleString(undefined, {
        day:    '2-digit',
        month:  '2-digit',
        year:   'numeric',
        hour:   '2-digit',
        minute: '2-digit',
        hour12: false,
      })}. Actuals can only be submitted after the shift has ended.`
    );
    return;
  }

  // ── Existing validation ────────────────────────────────────────────────
  if (!actualStart.trim() || !actualFinish.trim() || !actualPersonWorked.trim()) {
    alert('Please fill in all actuals details before proceeding.');
    return;
  }
  const validStatuses = ['Complete', 'Not-Worked'];
  if (!actualStatus || !validStatuses.includes(actualStatus)) {
    alert('Please select a valid Actual Status: either "Complete" or "Not-Worked".');
    return;
  }
    if (actualFillerType === 'staff' && !actualfilledBy) {
        toast.error('Please select which staff member actually worked the shift.');
        return;
      }
      if (actualFillerType === 'agency' && (!actualFilledByAgency || !actualFilledByAgencyWorkerName.trim())) {
        toast.error('Please select the agency and enter the worker name.');
        return;
      }


      if (needsFillerSwapSplit()) {
  setPendingSwapPayload({
    shiftId,
    fillerType: actualFillerType,
    actualfilledBy,
    actualFilledByAgency,
    actualFilledByAgencyName,
    actualFilledByAgencyWorkerName,
    actualFilledByAgencyWorkerContact,
    actualFilledByAgencyWorkerEmail,
    actualPersonWorked,
    actualStart: localInputToUtcISO(actualStart),
    actualFinish: localInputToUtcISO(actualFinish),
    managerId: userInfo._id,
  });
  setSwapCancelledByType('');
  setSwapAdvanceNoticeGiven(null);
  setSwapConfirmModalOpen(true);
  return;
}

// ── existing normal save path continues unchanged below ──


  try {
    const updateData = {
      shiftId,
      hospitalLocationId,
      wardDepartmentArea,
      actualStart: localInputToUtcISO(actualStart),
      actualFinish: localInputToUtcISO(actualFinish),
      actualPersonWorked,
      actualStatus,
      comments,
      stage2WardApprovalManager,
      updatedBy: userInfo._id,
    };

    if (actualFillerType === 'staff') {
      updateData.actualfilledBy = actualfilledBy;
      updateData.actualFilledByAgency = null;
      updateData.actualFilledByAgencyName = '';
      updateData.actualFilledByAgencyWorkerName = '';
      updateData.actualFilledByAgencyWorkerContact = '';
      updateData.actualFilledByAgencyWorkerEmail = '';
    } else {
      updateData.actualfilledBy = null;
      updateData.actualFilledByAgency = actualFilledByAgency;
      updateData.actualFilledByAgencyName = actualFilledByAgencyName;
      updateData.actualFilledByAgencyWorkerName = actualFilledByAgencyWorkerName;
      updateData.actualFilledByAgencyWorkerContact = actualFilledByAgencyWorkerContact;
      updateData.actualFilledByAgencyWorkerEmail = actualFilledByAgencyWorkerEmail;
    }

    if (locationChanged) updateData.locationUpdated = true;

    await updateShift(updateData).unwrap();
    toast.success('Shift updated successfully');
    navigate('/manager/approved-filled');
  } catch (err) {
    toast.error(err?.data?.message || err.error);
  }
};

// Handle cancel button - go back without saving
  const handleCancel = () => {
    navigate('/manager/approved-filled');
  };


  {/*
  const submitHandler = async (e) => {
    e.preventDefault();

 
  // Validate that all actuals fields are filled
  if (!actualStart.trim() || !actualFinish.trim() || !actualPersonWorked.trim()) {
    alert('Please fill in all actuals details before proceeding.');
    return;
  }

 // Enhanced validation for actualStatus - must be either "Complete" or "Not-Worked"
  const validStatuses = ['Complete', 'Not-Worked'];
  if (!actualStatus || !validStatuses.includes(actualStatus)) {
    alert('Please select a valid Actual Status: either "Complete" or "Not-Worked".');
    return;
  }
  

   //console.log("hospitalLocationId",hospitalLocationId)
   //console.log("shiftId",shiftId)
    try {
      await updateShift({
        shiftId,
        startDateTime,
        endDateTime,
        hospitalLocationId,
        wardDepartmentArea,
        reasonForRequest,
        reasonForRequestDetails,
        categoryOfStaff,
        escort,
        special,
        
        eccNumber,
        specialRequirements,
        comments,
        actualStart,
  actualFinish,
  actualPersonWorked,
  actualStatus,
  stage2WardApprovalManager,

      }).unwrap();
      toast.success('Shift updated successfully');
      navigate('/admin/approved-filled');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

*/}

  useEffect(() => {
          // Enable full-width container
          setFluid(true);
      
          return () => {
            // Reset back to normal when screen unmounts
            setFluid(false);
          };
        }, [setFluid]);

  //typeOfShift,
// <h1>Open Ward Shifts for Approval</h1>
  return (
    <FormContainer>
      

      {loadingUpdate && <Loader />}
      {loadingShift || loadingLocations ? (
        <Loader />
      ) : errorShift ? (
        <Message variant="danger">
          {errorShift?.data?.message || errorShift.error}
        </Message>
      ) : errorLocations ? (
        <Message variant="danger">
          {errorLocations?.data?.message || errorLocations.error}
        </Message>
      ) : (
        <Form >

          {/* Supersede link indicators */}
{shift?.supersedesShiftId && (
  <Alert variant="info" className="d-flex justify-content-between align-items-center mb-3">
    <div>
      <strong>↩ This shift replaces a previous shift</strong>{' '}
      that was marked <strong>Not-Worked</strong> after the actual filler changed
      {shift.supersedesShiftId.poNumber && (
        <> (previous PO: <strong>{shift.supersedesShiftId.poNumber}</strong>)</>
      )}
      .
    </div>
    <Button
      size="sm"
      variant="outline-secondary"
      onClick={() =>
        navigate(`/${userInfo.isAdmin ? 'admin' : 'manager'}/shiftsWard/${shift.supersedesShiftId._id}/edit`)
      }
    >
      View Original Shift
    </Button>
  </Alert>
)}

{shift?.supersededByShiftId && (
  <Alert variant="warning" className="d-flex justify-content-between align-items-center mb-3">
    <div>
      <strong>⚠ This shift has been marked Not-Worked</strong> — the actual filler
      was changed and a replacement shift was created
      {shift.supersededByShiftId.poNumber && (
        <> (new PO: <strong>{shift.supersededByShiftId.poNumber}</strong>)</>
      )}
      . Any updates should be made on the replacement shift instead.
    </div>
    <Button
      size="sm"
      variant="outline-primary"
      onClick={() =>
        navigate(`/${userInfo.isAdmin ? 'admin' : 'manager'}/shiftsWard/${shift.supersededByShiftId._id}/edit`)
      }
    >
      Go to Replacement Shift
    </Button>
  </Alert>
)}


 {isFinalised && (
      <Alert variant="warning" className="mb-3">
        <strong>This shift has been finalised</strong> ({shift.actualStatus}
        {shift.supersededByShiftId ? ' — superseded by a replacement shift' : ''})
        and can no longer be edited here.
        {shift.supersededByShiftId && (
          <>
            {' '}
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={() => navigate(`/${window.location.pathname.includes('/admin/') ? 'admin' : 'manager'}/shiftsWard/${shift.supersededByShiftId}/edit`)}
            >
              Open Replacement Shift
            </Button>
          </>
        )}
      </Alert>
    )}
    

          <Card className="mb-4 custom-card-bg">
  <Card.Header className="fw-bold">Manager: Ward Approvals: Actuals</Card.Header>
  <Card.Body>
    <Form.Group controlId="copyActualsCheckbox" className="mb-3">
      
      
      <Form.Check
        type="checkbox"
        label="Copy planned Start/End and Staff into Actuals"
        checked={copyActualsChecked}
        onChange={(e) => {
          const checked = e.target.checked;
          setCopyActualsChecked(checked);

          if (checked) {
            setActualStart(startDateTime);
            setActualFinish(endDateTime);

            if (shift.filledByAgency) {
              setActualFillerType('agency');
              setActualPersonWorked(shift.filledByAgencyWorkerName || '');
              setActualfilledBy('');
              setActualFilledByAgency(shift.filledByAgency?._id || shift.filledByAgency || '');
              setActualFilledByAgencyName(shift.filledByAgencyName || '');
              setActualFilledByAgencyWorkerName(shift.filledByAgencyWorkerName || '');
              setActualFilledByAgencyWorkerContact(shift.filledByAgencyWorkerContact || '');
              setActualFilledByAgencyWorkerEmail(shift.filledByAgencyWorkerEmail || '');
            } else {
              setActualFillerType('staff');
              setActualPersonWorked(shift.filledByName || '');
              setActualfilledBy(shift.filledBy?._id || shift.filledBy || '');
              setActualFilledByAgency('');
              setActualFilledByAgencyName('');
              setActualFilledByAgencyWorkerName('');
              setActualFilledByAgencyWorkerContact('');
              setActualFilledByAgencyWorkerEmail('');
            }
          }
        }}
      />



    </Form.Group>

    <Form.Group className="mb-3">
  <Form.Label className="fw-bold d-block">Who actually worked this shift?</Form.Label>
  <div className="d-flex gap-2">
    <Button
      variant={actualFillerType === 'staff' ? 'primary' : 'outline-secondary'}
      size="sm"
      onClick={() => setActualFillerType('staff')}
    >
      Staff Member
    </Button>

{/*
    <Button
      variant={actualFillerType === 'agency' ? 'primary' : 'outline-secondary'}
      size="sm"
      onClick={() => setActualFillerType('agency')}
    >
      Agency Worker
    </Button>
*/}


  </div>
  <Form.Text className="text-muted">
    Use this if an agency covered the shift instead of the originally rostered staff member (or vice versa).
  </Form.Text>
</Form.Group>

{actualFillerType === 'staff' ? (
  <Row className="mb-3">
    <Col md={6}>
      <Form.Group controlId="actualfilledBy">
        <Form.Label>Select Staff Member Who Worked</Form.Label>
        <Form.Select
          value={actualfilledBy}
          onChange={(e) => {
            const selectedId = e.target.value;
            setActualfilledBy(selectedId);
            const staff = staffData?.find((s) => s._id === selectedId);
            if (staff) setActualPersonWorked(staff.name);
          }}
        >
          <option value="">Select staff member...</option>
          {staffData
            ?.filter((u) => !u.isAdmin && !u.isAgency)
            .map((s) => (
              <option key={s._id} value={s._id}>
                {s.name} {s.jobtitle ? `(${s.jobtitle})` : ''}
              </option>
            ))}
        </Form.Select>
        <Form.Text className="text-muted">
          This sets the linked staff record (<code>actualfilledBy</code>) used for reporting.
        </Form.Text>
      </Form.Group>
    </Col>
  </Row>
) : (
  <>
    {(shift.poNumber || actualFillerType === 'agency') && (
      <Row className="mb-3">
        <Col md={12}>
          {shift.poNumber ? (
            <div
              className="d-flex align-items-center gap-2 p-2 px-3 rounded"
              style={{ backgroundColor: '#e8f4fd', border: '1px solid #b6e0fe' }}
            >
              <span className="text-muted small">Ref Number:</span>
              <span className="fw-bold fs-7">{shift.poNumber}</span>
              <span className="text-muted small ms-auto fst-italic">
                Use this reference on invoices
              </span>
            </div>
          ) : (
            <div className="text-muted small fst-italic">
              A Ref number will be generated automatically when you save.
            </div>
          )}
        </Col>
      </Row>
    )}

    <Row className="mb-3">
            <Col md={4}>
          <Form.Group controlId="actualFilledByAgency">
            <Form.Label>Agency</Form.Label>
            <Form.Select
                value={actualFilledByAgency}
                disabled={isManager && !isAdmin}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  setActualFilledByAgency(selectedId);
                  const agency = agenciesData?.find((a) => a._id === selectedId);
                  setActualFilledByAgencyName(agency?.agencyName || '');

                  // Default the worker contact/email to the new agency's own details —
                  // this was previously left as whatever the last-selected agency's
                  // worker had typed in, which is misleading once the agency changes.
                  // The user can still overwrite these with the specific worker's own
                  // details if they have them.
                  setActualFilledByAgencyWorkerContact(agency?.agencyPhone || '');
                  setActualFilledByAgencyWorkerEmail(agency?.agencyEmail || '');
                }}
              >
                <option value="">Select agency...</option>
                {agenciesData?.map((a) => (
                  <option key={a._id} value={a._id}>
                    {a.agencyName} ({a.agencyTier})
                  </option>
                ))}
              </Form.Select>
              {isManager && !isAdmin && (
                <Form.Text className="text-muted">
                  Only an admin can change the assigned agency. You can still reassign this shift to a staff member.
                </Form.Text>
              )}
          </Form.Group>
        </Col>
      <Col md={4}>
        <Form.Group controlId="actualFilledByAgencyWorkerName">
          <Form.Label>Agency Worker Name</Form.Label>
          <Form.Control
            type="text"
            value={actualFilledByAgencyWorkerName}
            onChange={(e) => {
              setActualFilledByAgencyWorkerName(e.target.value);
              setActualPersonWorked(e.target.value);
            }}
          />
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group controlId="actualFilledByAgencyWorkerContact">
          <Form.Label>Worker Contact</Form.Label>
          <Form.Control
            type="text"
            value={actualFilledByAgencyWorkerContact}
            onChange={(e) => setActualFilledByAgencyWorkerContact(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={4} className="mt-3">
        <Form.Group controlId="actualFilledByAgencyWorkerEmail">
          <Form.Label>Worker Email (optional)</Form.Label>
          <Form.Control
            type="email"
            value={actualFilledByAgencyWorkerEmail}
            onChange={(e) => setActualFilledByAgencyWorkerEmail(e.target.value)}
          />
        </Form.Group>
      </Col>
    </Row>
  </>
)}


    <Row className="mb-3">
      <Col md={3}>
        <Form.Group controlId="actualStart">
          <Form.Label>Actual Start</Form.Label>
          <Form.Control
            type="datetime-local"
            value={actualStart}
            onChange={(e) => setActualStart(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group controlId="actualFinish">
          <Form.Label>Actual Finish</Form.Label>
          <Form.Control
            type="datetime-local"
            value={actualFinish}
            onChange={(e) => setActualFinish(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group controlId="actualPersonWorked">
          <Form.Label>Actual Person Worked</Form.Label>
          <Form.Control
            type="text"
            value={actualPersonWorked}
            onChange={(e) => setActualPersonWorked(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group controlId="actualStatus">
          <Form.Label>Actual Status</Form.Label>
          <Form.Select
            value={actualStatus}
            onChange={(e) => setActualStatus(e.target.value)}
          >
            <option value="">Select...</option>
            <option value="Complete">Complete</option>
            <option value="Not-Worked">Not-Worked</option>
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>

    <Form.Group controlId="comments">
      <Form.Label>Comments</Form.Label>
      <Form.Control
        as="textarea"
        rows={3}
        value={comments}
        onChange={(e) => setComments(e.target.value)}
      />
    </Form.Group>

    


     {/* Action Buttons  <Button type="submit" variant="primary" className="mt-2">
      Update Shift
    </Button> */}
    <Row className="mb-3"></Row>
    <Row className="mb-3">
          <div className="d-flex gap-2 justify-content-between">
            <div>
              <Button 
                type="button" 
                variant="primary" 
                onClick={handleSaveAllChanges}
                disabled={loadingUpdate}
              >
                {loadingUpdate ? 'Saving...' : 'Save All Changes & Close'}
              </Button>
            </div>
            <div>
              <Button 
                type="button" 
                variant="secondary" 
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
          </div>
      </Row>

  </Card.Body>
</Card>

  {/* Planned Shift Details Card - With separate save button */}
  <Card className="mb-4 custom-card-bg">
    <Card.Header className="fw-bold">Planned Shift Details</Card.Header>

    <Card.Header className="fw-bold d-flex justify-content-between align-items-center">
              <span>Planned Shift Details</span>
              {locationChanged && (
                <Button 
                  variant="success" 
                  size="sm"
                  onClick={handleSaveLocationOnly}
                  disabled={loadingUpdate}
                >
                  {loadingUpdate ? 'Saving...' : 'Save Location Change Only'}
                </Button>
              )}
            </Card.Header>

    <Card.Body>
      <Row className="mb-3">
        <Col md={2}>
                  <Form.Group controlId="hospitalLocationId">
                    <Form.Label>Hospital Location</Form.Label>
                    <Form.Select 
                      value={hospitalLocationId} 
                      onChange={handleHospitalLocationChange}
                      className={locationChanged ? 'border-warning' : ''}
                    >
                      <option value="">Select...</option>
                      {hospitalLocations.map((location) => (
                        <option key={location._id} value={location._id}>
                          {location.wardDepartmentArea} 
                        </option>
                      ))}
                    </Form.Select>
                    {locationChanged && (
                      <Form.Text className="text-warning">
                        ⚠️ Location changed - click "Save Location Change Only" to update
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

        <Col md={2}>
          <Form.Group controlId="categoryOfStaff">
            <Form.Label>Category of Staff</Form.Label>
            <Form.Select value={categoryOfStaff} disabled>
              <option value="">Select...</option>
              {CATEGORY_OF_STAFF.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={4}>
                    <Form.Group controlId="reasonForRequest">
                      <Form.Label>Reason for Request</Form.Label>
                      <div className="d-flex gap-2 align-items-center">
                        <Form.Select value={reasonForRequest} disabled>
                          <option value="">Select...</option>
                          {REASON_FOR_REQUEST.map((r) => (
                            <option key={r.value} value={r.value}>
                              {r.label}
                            </option>
                          ))}
                        </Form.Select>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          disabled={isFinalised}
                          onClick={() => {
                            setReasonForRequestDraft(reasonForRequest || '');
                            setSpecialsReasonDraft(specialsReason || '');
                            setReasonModalOpen(true);
                          }}
                        >
                          Change
                        </Button>
                      </div>
                      {isFinalised && (
                        <Form.Text className="text-muted">
                          This shift has been finalised and its reason can no longer be changed.
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>

                 {['1-1 special', 'Cohorts'].some(
                        r => reasonForRequest?.toLowerCase() === r.toLowerCase()
                      ) && (
                        <Col md={4}>
                          <Form.Group controlId="specialsReason">
                            <Form.Label>Specials / Cohorts Reason</Form.Label>
                            <div className="d-flex gap-2 align-items-center">
                              <Form.Control
                                type="text"
                                value={specialsReason || 'Not recorded'}
                                readOnly
                                className={!specialsReason ? 'border-warning text-warning' : ''}
                              />
                              {/*
                              <Button
                                variant={specialsReason ? 'outline-secondary' : 'warning'}
                                size="sm"
                                disabled={isFinalised}
                                onClick={() => {
                                  setReasonForRequestDraft(reasonForRequest || '');
                                  setSpecialsReasonDraft(specialsReason || '');
                                  setReasonModalOpen(true);
                                }}
                              >
                                {specialsReason ? 'Change' : 'Add'}
                              </Button>
                              */}

                              
                            </div>
                            {!specialsReason && !isFinalised && (
                              <Form.Text className="text-warning">
                                ⚠️ No specials reason recorded — click Add to enter one
                              </Form.Text>
                            )}
                            {isFinalised && (
                              <Form.Text className="text-muted">
                                This shift has been finalised and can no longer be changed.
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>
                      )}


        <Col md={4}>
          <Form.Group controlId="reasonForRequestDetails">
            <Form.Label>Reason for Request Details</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reasonForRequestDetails}
              readOnly
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Group controlId="startDateTime">
            <Form.Label>Start Date & Time</Form.Label>
            <Form.Control type="datetime-local" value={startDateTime} readOnly />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="endDateTime">
            <Form.Label>End Date & Time</Form.Label>
            <Form.Control type="datetime-local" value={endDateTime} readOnly />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="eccNumber">
            <Form.Label>ECC Number</Form.Label>
            <Form.Control type="text" value={eccNumber} readOnly />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Label className="fw-bold">Selections</Form.Label>
          <Form.Group controlId="escort" className="mb-2">
            <Form.Check
              type="checkbox"
              label="Escort Required"
              checked={escort}
              disabled
            />
          </Form.Group>
          <Form.Group controlId="special">
            <Form.Check
              type="checkbox"
              label="Is this a Special"
              checked={special}
              disabled
            />
          </Form.Group>
        </Col>
      </Row>

      <Form.Group controlId="specialRequirements" className="mb-2">
        <Form.Label>Any Special Requirements</Form.Label>
        <Form.Control as="textarea" rows={3} value={specialRequirements} readOnly />
      </Form.Group>
    </Card.Body>
  </Card>


  





 




</Form>
      )}


{swapConfirmModalOpen && (
  <div
    className="modal show d-block"
    style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    tabIndex="-1"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title fw-bold">Confirm Replacement</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setSwapConfirmModalOpen(false)}
          />
        </div>
        <div className="modal-body">
          <div className="alert alert-warning">
            Changing the actual filler will preserve the original shift as
            <strong> Not-Worked</strong> and create a new shift for the replacement,
            with its own Ref if agency-filled.
          </div>

          <label className="fw-bold d-block mb-2">
            Who is responsible for this replacement? <span className="text-danger">*</span>
          </label>
          <div className="d-flex gap-2 mb-3">
            <Button
              variant={swapCancelledByType === 'Agency' ? 'primary' : 'outline-secondary'}
              onClick={() => setSwapCancelledByType('Agency')}
            >
              Agency
            </Button>
            <Button
              variant={swapCancelledByType === 'Beaumont' ? 'primary' : 'outline-secondary'}
              onClick={() => setSwapCancelledByType('Beaumont')}
            >
              Beaumont
            </Button>
          </div>

          {swapCancelledByType === 'Beaumont' && (
                  <>
                    <label className="fw-bold d-block mb-2">
                      Was the agency given at least 12 hours notice? <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-2 mb-2">
                      <Button
                        variant={swapAdvanceNoticeGiven === true ? 'success' : 'outline-secondary'}
                        onClick={() => setSwapAdvanceNoticeGiven(true)}
                      >
                        Yes — 12+ hours notice
                      </Button>
                      <Button
                        variant={swapAdvanceNoticeGiven === false ? 'danger' : 'outline-secondary'}
                        onClick={() => setSwapAdvanceNoticeGiven(false)}
                      >
                        No — less than 12 hours
                      </Button>
                    </div>
                    {swapAdvanceNoticeGiven === false && (
                      <div className="alert alert-danger">
                        ⚠️ A charge will apply — the agency was not given 12 hours notice.
                      </div>
                    )}
                    {swapAdvanceNoticeGiven === true && (
                      <div className="alert alert-success">
                        No charge applies — sufficient notice was given.
                      </div>
                    )}
                  </>
                )}
                {swapCancelledByType === 'Agency' && (
                  <div className="alert alert-info">
                    No charge applies when the agency is responsible for the replacement.
                  </div>
                )}
        </div>
        <div className="modal-footer d-flex justify-content-between">
          <Button variant="secondary" onClick={() => setSwapConfirmModalOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirmSwap}
            disabled={
              !swapCancelledByType ||
              (swapCancelledByType === 'Beaumont' && swapAdvanceNoticeGiven === null) ||
              loadingUpdate
            }
          >
            Confirm Replacement
          </Button>
        </div>
      </div>
    </div>
  </div>
)}

      {reasonModalOpen && (
  <div
    className="modal show d-block"
    style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    tabIndex="-1"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title fw-bold">Change Reason for Request</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setReasonModalOpen(false)}
          />
        </div>
        <div className="modal-body">
          <Form.Group controlId="reasonForRequestDraft" className="mb-3">
            <Form.Label className="fw-bold">
              Reason for Request <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              value={reasonForRequestDraft}
              onChange={(e) => setReasonForRequestDraft(e.target.value)}
              size="lg"
            >
              <option value="">Select...</option>
              {REASON_FOR_REQUEST.map((r) => (
                <option key={r.value} value={r.value}>
                  {r.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {['1-1 special', 'Cohorts'].some(
            r => reasonForRequestDraft?.toLowerCase() === r.toLowerCase()
          ) && (
            <Form.Group controlId="specialsReasonDraft">
              <div className="alert alert-warning">
                This is a <strong>{reasonForRequestDraft}</strong> shift. Please select
                the clinical reason before proceeding.
              </div>
              <Form.Label className="fw-bold">
                Specials / Cohorts Reason <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                value={specialsReasonDraft}
                onChange={(e) => setSpecialsReasonDraft(e.target.value)}
                size="lg"
              >
                <option value="">Select reason...</option>
                {SPECIALS_REASON.map((r) => (
                  <option key={r.value} value={r.value}>
                    {r.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          )}
        </div>
        <div className="modal-footer d-flex justify-content-between">
          <Button variant="secondary" onClick={() => setReasonModalOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveReasonChanges}
            disabled={
              !reasonForRequestDraft ||
              (['1-1 special', 'Cohorts'].some(
                r => reasonForRequestDraft?.toLowerCase() === r.toLowerCase()
              ) && !specialsReasonDraft) ||
              loadingUpdate
            }
          >
            {loadingUpdate ? 'Saving...' : 'Save Changes'}
          </Button>
        </div>
      </div>
    </div>
  </div>
)}


    </FormContainer>
  );
};

export default ShiftWardEditScreen;


